export enum ProjectErrorFieldSource {
  ProjectKey = 'projectKey',
  Repository = 'repository',
  Branch = 'branch',
}
